import React from 'react';
import { IconLoader } from 'common/IconLoader';
import SvgAF from '../SvgAF/SvgAF';

import './WarningBox.css';

const WarningBox = ({ warningMessages, className }) => {
  const formattedMessages = !Array.isArray(warningMessages) ? [warningMessages] : warningMessages;
  return (
    <div className={className ?? 'WarningBox_Container'}>
      <div className="WarningBox_IconContainer">
        <SvgAF img={IconLoader.icon_warning_round} hover={IconLoader.icon_warning_round} />
      </div>
      <div>
        {formattedMessages.map((message, i) => (
          <div className="WarningBox_TextContainer" key={i} data-tip={message}>
            {message}
          </div>
        ))}
      </div>
    </div>
  );
};

export default WarningBox;
